import React, { useEffect, useState } from 'react';
import { isSbsApp, isAndroid } from '../../../../src/common/utils/passUtil';
import { isVirtualChannel } from '../../../../src/common/utils/liveUtil';

export default function QuickButtons({
  jwt,
  smr_programid,
  cpid,
  program_title,
  channelid,
  channelname,
  thumbnail,
  home_url,
  vod_url,
  chats,
  share_title,
}) {
  const [isLiked, setIsLiked] = useState(false);

  useEffect(async () => {
    fetchProgramLike('get', smr_programid, jwt);
  }, [smr_programid, jwt]);

  // URL에 ref 파라미터를 추가(GA통계용)
  const addRefParam = (url) => {
    if (!url) return null;
    const separator = url.includes('?') ? '&' : '?';
    return isVirtualChannel(channelid) ? `${url}${separator}ref=24tv` : url;
  };
  const homeLinkUrl = addRefParam(home_url);
  // const allVodLinkUrl = addRefParam(vod_url);
  const handleClickHome = (event) => {
    event.preventDefault();
    event.stopPropagation();
    console.log('homeLinkUrl', homeLinkUrl);
    handleClickLink(homeLinkUrl);
  };

  const fetchProgramLike = async (method = 'get', pgmId, jwtToken) => {
    try {
      const apiUrl = process.env.NEXT_PUBLIC_API_LIVE_PROGRAM_LIKE_SEND_V2;
      if (!apiUrl) {
        throw new Error('API URL이 설정되지 않았습니다.');
      }

      const response = await fetch(`${apiUrl}/${pgmId}`, {
        method: method.toUpperCase(),
        headers: { 'jwt-token': jwtToken },
      });

      if (!response.ok) {
        if (response.status === 401) {
          if (
            method.toLowerCase() === 'put' ||
            method.toLowerCase() === 'delete'
          )
            if (confirm('로그인 후 이용 가능합니다. 로그인 하시겠습니까?')) {
              // * 로그인 연동
              window.location.href =
                'https://join.sbs.co.kr/login/login.do?returnUrl=' +
                encodeURIComponent(window.location.href);
            }
          throw new Error('로그인 권한이 없습니다.');
        }
        throw new Error('잘못된 요청 입니다..');
      }

      const result = await response.json();
      if (method.toLowerCase() === 'put') {
        setIsLiked(true);
      } else if (method.toLowerCase() === 'delete') {
        setIsLiked(false);
      }

      if (result[pgmId]?.is_like !== undefined) {
        setIsLiked(result[pgmId].is_like);
      }
    } catch (error) {
      console.error('Error fetching program like:', error);
    }
  };

  const handleClickLink = (url) => {
    if (isSbsApp()) {
      if (isAndroid()) {
        window.location.href = `intent://programhome?programid=${smr_programid}&cpid=${cpid}&programtitle=${encodeURIComponent(
          program_title
        )}#Intent;scheme=siapp;package=kr.co.sbs.videoplayer;end`;
      } else {
        window.location.href = `siapp://programhome?programid=${smr_programid}&cpid=${cpid}&programtitle=${encodeURIComponent(
          program_title
        )}`;
      }
    } else {
      window.location.href = url;
    }
  };

  const handleClickLike = (event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    // if (isLiked) {
    //   setIsLiked(false);
    //   return;
    // }
    if (isSbsApp() && !jwt) {
      if (isAndroid()) {
        window.location.href = `intent://login?type=program_like#Intent;scheme=siapp;package=kr.co.sbs.videoplayer;end`;
      } else {
        window.location.href = `siapp://login?type=program_like`;
      }
    } else {
      // 좋아요 API 호출 및 처리
      if (!smr_programid) return;
      fetchProgramLike(isLiked ? 'delete' : 'put', smr_programid, jwt);
    }
  };

  const handleClickChat = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    window.__SBSLogModuleDataLayer = window.__SBSLogModuleDataLayer || [];
    window.__SBSLogModuleDataLayer.push({
      type: 'click',
      option: {
        clickName: '플레이어/플레이톡/웹',
        clickType: 'NC',
        value1: '', // optional
        value2: '', // optional
        value3: '', // optional
        value4: '', // optional
        value5: '', // optional
      },
    });

    try {
      if (isSbsApp()) {
        // 기존 앱 처리 로직
        const url = isAndroid()
          ? `intent://playtalk?type=live&channelid=${channelid}#Intent;scheme=siapp;package=kr.co.sbs.videoplayer;end`
          : `siapp://playtalk?type=live&channelid=${channelid}`;
        window.location.href = url;
      } else {
        // 웹 처리 로직에 재시도 로직 추가
        const confirmed = confirm(
          `플레이톡은 앱에서만 가능합니다. 'SBS play' 에서 열겠습니까?`
        );
        if (confirmed) {
          const url = isAndroid()
            ? `intent://home?tab=home#Intent;scheme=siapp;package=kr.co.sbs.videoplayer;end`
            : `siapp://playtalk?type=live&channelid=${channelid}`;
          window.location.href = url;
        }
      }
    } catch (error) {
      console.error('채팅 처리 중 오류:', error);
    }
  };

  const handleClickShare = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (isSbsApp()) {
      if (!channelid || !channelname || !thumbnail) {
        alert('프로그램 정보가 없습니다.');
        return;
      }
      if (isAndroid()) {
        window.location.href = `intent://share?type=live&channelId=${channelid}&channelName=${encodeURIComponent(
          channelname
        )}&thumnail=${encodeURIComponent(
          thumbnail
        )}&programTitle=${encodeURIComponent(
          program_title
        )}#Intent;scheme=siapp;package#Intent;scheme=siapp;package=kr.co.sbs.videoplayer;end`;
      } else {
        window.location.href = `siapp://share?type=live&channelId=${channelid}&channelName=${encodeURIComponent(
          channelname
        )}&thumnail=${encodeURIComponent(
          thumbnail
        )}&programTitle=${encodeURIComponent(program_title)}`;
      }
    } else if (navigator.share) {
      navigator.share({
        title: document.title,
        text: share_title,
        url: location.href,
      });
    }
  };

  // TODO: 2024/09/13 'S21' 만 스타TV로 편성된다는 전제하에 해당 채널만 홈 미노출
  return (
    <ul className="quickBtn_w">
      {channelid !== 'S21' &&
        (isSbsApp()
          ? smr_programid &&
            cpid &&
            homeLinkUrl &&
            homeLinkUrl.indexOf('programs.sbs.co.kr')
          : homeLinkUrl) && (
          <li>
            <a onClick={handleClickHome} className="btnIcon01_home">
              <span className="ico_home">
                <i className="ir">홈</i>
              </span>
            </a>
          </li>
        )}
      <li>
        <a onClick={handleClickShare} className="btnIcon01_share">
          <span className="ico_share">
            <i className="ir">공유</i>
          </span>
        </a>
      </li>
      {smr_programid && (
        <li>
          <button
            onClick={handleClickLike}
            type="button"
            className={`btnIcon01_like_toggle ${isLiked ? 'active' : ''}`}
          >
            <span className="ico_like_on">
              <i className="ir">좋아요</i>
            </span>
            <span className="ico_like_off">
              <i className="ir">좋아요 전</i>
            </span>
          </button>
        </li>
      )}
      <li>
        <a onClick={handleClickChat} className="btnIcon01_talk">
          <span className="ico_talk">
            <i className="ir">채팅</i>
          </span>
        </a>
      </li>
    </ul>
  );
}
